import { spiderAbdomen, spiderHead, spiderLegs } from "./Silhouettes";

/** A witch hat on the Q and a spider dangling from the k, positioned against a `mx-2 h-7` QwickLogo. */
export const LogoDecor = () => (
  <>
    <svg
      aria-hidden="true"
      viewBox="0 0 24 18"
      width="24"
      height="18"
      className="pointer-events-none absolute -top-1.75 left-1.5 origin-bottom -rotate-12 overflow-visible"
    >
      <path
        className="fill-brand"
        d="M6 14.8 C8.5 10 10.5 5.5 12.6 2.2 C13.4 1 14.6 0.6 16.6 1.4 C18 2 19 2.8 20.2 2.4 C18.8 3.8 16.6 3.6 15.6 4.4 C15.4 7.8 16.6 11.4 18 14.8 Z"
      />
      <path
        className="fill-amber"
        d="M7.6 11.2 C10.7 11.9 13.5 11.9 16.5 11.1 L17.5 13.9 C13.9 14.9 10.3 14.9 6.5 14 Z"
      />
      <ellipse className="fill-brand" cx="12" cy="15.4" rx="11.5" ry="2.3" />
    </svg>
    <svg
      aria-hidden="true"
      viewBox="0 0 17 31"
      width="17"
      height="31"
      className="pointer-events-none absolute top-1 left-15 overflow-visible"
    >
      <g className="halloween-spider-sway">
        <line className="halloween-thread-grow stroke-white/35" x1="4.6" y1="2.2" x2="8.5" y2="19" strokeWidth="0.6" />
        <g className="animate-spider-drop motion-reduce:animate-none">
          <g fill="none" strokeWidth="0.8" strokeLinecap="round" strokeLinejoin="round" className="stroke-white/80">
            {spiderLegs.map((d) => (
              <path key={d} d={d} />
            ))}
          </g>
          <ellipse className="fill-white/80" {...spiderAbdomen} />
          <circle className="fill-white/80" {...spiderHead} />
          <circle className="fill-brand-hover" cx="7.8" cy="20.1" r="0.45" />
          <circle className="fill-brand-hover" cx="9.2" cy="20.1" r="0.45" />
        </g>
      </g>
    </svg>
  </>
);
